import { sessionApiClient } from "@planningcenter/cc-api-client"
import { useSuspenseQuery } from "@tanstack/react-query"

export function useBuiltinFieldRules() {
  const url = "/accounts/v2/church_center_settings"

  const response = useSuspenseQuery({
    queryFn: () => sessionApiClient.get(url),
    queryKey: ["accounts", "church_center_settings"],
    select: (response) => response.data.attributes.built_in_field_rules,
  })

  return response.data
}
